<template>
    <div style="height: 700px" :style="$vuetify.breakpoint.lgAndUp ? 'width:1280px' : ''" class="wrapper-relative">
        <v-icon class="modal-close" data-test="close-avatar" @click.native="CLOSE_MODAL('avatar_modal')" aria-hidden="true" translate="no">close</v-icon>
        <v-layout justify-center align-center class="height--100">
            <img :src="image | avatar" class="avatar">
        </v-layout>
    </div>
</template>

<script>
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  props: {
    image: {
      type: String,
    },
  },
  beforeCreate() {
    document.documentElement.style.overflow = 'hidden';
  },
  beforeDestroy() {
    document.documentElement.style.overflow = 'auto';
  },
  methods: {
    ...mapMutations('common/modals', [
      'CLOSE_MODAL',
    ]),
  },
};
</script>

